import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { IP } from "../../../internalServer";
import moment from "moment";
import axios from '../../../axios'
import Slider from "react-slick";
import { Popup } from "semantic-ui-react";
import LikePopUp from "../../StudentQuery/Reply Query/LikePopUp";
import CreatePostFirst from "../Create_Post_screen/CreatePostFirst";
import assets from "../../../assets/assets";
import ThreeDot_Post_Popup from "../total_community_post/recent_post Img/ThreeDot_Post_Popup";
import HeaderContext from "../../../HeaderContext";

function PostImagePopup({
    commentLength,
    post,
    TotalCommuPost,
    refetch,
    setIsPostCreated1,
    community,
    members,
    setCommentCount
}) {

    const studentData = JSON.parse(localStorage.getItem("breathForStudent"));
    const popupRef = useRef(null);
    const [replycpy, setreplyCnt] = useState(post);
    const [postThreedot, setPostThreedot] = useState("");
    const [postLikeClick, setPostLikeClick] = useState(false);
    const [postLlikeCount, setPostLlikeCount] = useState(post?.like_count);
    const currentUser = useSelector((state) => state.user.currentUser);
    const [currentSlide, setCurrentSlide] = useState(1);
    const [postEdit, setPostEdit] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const { countComment } = useContext(HeaderContext);

    const handleSlideChange = (current) => {
        setCurrentSlide(current + 1);
    };

    const [likedRes, setLikedRes] = useState(null);
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        afterChange: handleSlideChange,
        arrows: true,
    };

    useEffect(() => {
        setPostLikeClick(
            post?.likes?.some((user) => user?.userId === currentUser?.id)
        );
    }, [post?.id]);

    const handelPostLike = async () => {
        try {
            let res = await axios.put(`/community/post/like/${post.id}`, {
                user_id: currentUser?.id,
            });
            setPostLlikeCount(
                postLikeClick ? postLlikeCount - 1 : postLlikeCount + 1
            );
            setPostLikeClick(!postLikeClick);
            setLikedRes(res.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    const timeHelper = (a) => {
        const dateObj = new Date(a);
        // Adding 5 hours and 30 minutes to the date
        dateObj.setUTCHours(dateObj.getUTCHours() + 5);
        dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

        const day = dateObj.getUTCDate();
        const month = dateObj.getUTCMonth() + 1;
        const year = dateObj.getUTCFullYear();
        const hours = dateObj.getUTCHours();
        const minutes = dateObj.getUTCMinutes();
        const seconds = dateObj.getUTCSeconds();

        const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return outputDateString;
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setPostThreedot(false);
        }
    };
    useEffect(() => {
        if (likedRes) {
            setreplyCnt((prevReply) => ({ ...prevReply, ...likedRes }));
        }
    }, [likedRes]);
    return (
        <>
            <div
                className="post_img_container rounded-4 w-full"
                style={{ backgroundColor: "white" }}
            >
                <div
                    className="w-100 d-flex gap-2 flex-row"
                    style={{ padding: "5px 10px" }}
                >
                    {/* full post */}
                    <div className="p-2 rounded-3 w-100" style={{ overflow: "hidden" }}>
                        <div className="w-100 d-flex flex-row ">
                            {/* Image */}
                            <div className="gap-2 mt-1 mb-3 d-flex ">
                                {post?.user_id?.user_type === "Teacher" ? (
                                    <img
                                        src={
                                            post?.user_id?.profile_picture
                                                ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                                                : post?.user_id?.gender === "M"
                                                    ? "/images/Teacher_Male.jpg"
                                                    : post?.user_id?.gender === "F"
                                                        ? "/images/Teacher_Female.png"
                                                        : "/images/default-profile.png"
                                        }
                                        alt="icon"
                                        className="profilePicImg"
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "20%",
                                        }}
                                        onError={(e) => {
                                            // This function will run if the image fails to load
                                            if (post?.user_id?.gender === "M") {
                                                e.target.src = "/images/Teacher_Male.jpg";
                                            } else if (post?.user_id?.gender === "F") {
                                                e.target.src = "/images/Teacher_Female.png";
                                            } else {
                                                e.target.src = "/images/default-profile.png";
                                            }
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={
                                            post?.user_id?.profile_picture
                                                ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                                                : post?.user_id?.gender === "M"
                                                    ? post?.user_id?.avatar_profile
                                                        ? "/images/Boys/" +
                                                        post?.user_id?.avatar_profile +
                                                        ".webp"
                                                        : "/images/Student_boy_pic.png"
                                                    : post?.user_id?.gender === "F"
                                                        ? post?.user_id?.avatar_profile
                                                            ? "/images/Girls/" +
                                                            post?.user_id?.avatar_profile +
                                                            ".webp"
                                                            : "/images/Student_girl_pic.png"
                                                        : "/images/default image.png"
                                        }
                                        alt="icon"
                                        className="prifilePicImg"
                                        key={post?.user_id?.avatar_profile}
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "20%",
                                        }}
                                        onError={(e) => {
                                            if (post?.user_id?.gender === "M") {
                                                // console.log("insie if")
                                                e.target.src = post?.user_id?.avatar_profile
                                                    ? "/images/Boys/" +
                                                    post?.user_id?.avatar_profile +
                                                    ".webp"
                                                    : "/images/Student_boy_pic.png";
                                            } else if (post?.user_id?.gender === "F") {
                                                e.target.src = post?.user_id?.avatar_profile
                                                    ? "/images/Girls/" +
                                                    post?.user_id?.avatar_profile +
                                                    ".webp"
                                                    : "/images/Student_girl_pic.png";
                                            } else {
                                                e.target.src = "/images/default image.png";
                                            }
                                        }}
                                    />
                                )}
                            </div>
                            <div className=" d-flex justify-content-between align-items-center px-4 py-1 w-100">
                                <div>
                                    <div className="d-flex align-items-center">
                                        {post?.user_id?.user_type === "Teacher" && (
                                            <img
                                                className="mr-2"
                                                src="/images/teacher_icon.svg"
                                                alt=""
                                            />
                                        )}
                                        <span className="request_channel_name mr-2">
                                            {post?.user_id?.name}
                                        </span>
                                        {post?.user_id?.user_type === "Student" && (
                                            <span className="request_channel_name mr-2">
                                                &nbsp;
                                                {post?.user_id?.standard?.name} -
                                                {post?.user_id?.section?.name}
                                            </span>
                                        )}
                                        <div className="m-0 p-0 post_tags_list d-flex align-items-center">
                                            {post?.tags?.length > 0 &&
                                                post?.tags.map((tag) => (
                                                    <span className="related_postName mx-1  px-2 py-1">
                                                        {tag}
                                                    </span>
                                                ))}
                                        </div>
                                    </div>
                                    <div className=" request_created_by">
                                        {post?.community_id?.community_name}
                                    </div>
                                    <small className=" request_created_by">
                                        {moment(timeHelper(post?.created_at)).calendar({
                                            sameDay: "[Today] hh:mm a",
                                            lastDay: "[Yesterday] hh:mm a",
                                            lastWeek: "DD MMM YYYY hh:mm a",
                                            sameElse: "DD MMM YYYY hh:mm a",
                                        })}
                                    </small>
                                </div>

                                {TotalCommuPost === "TotalCommuPost" ? null : (
                                    studentData?.id === post?.user_id?.id ? (<>
                                        {(!post?.isDeleted) ? (
                                            <img
                                                className="Post_HR_threedot"
                                                src="/images/three dot hr.svg"
                                                alt=""
                                                height="20px"
                                                width="20px"
                                                onClick={() => setPostThreedot(!postThreedot)}
                                            />
                                        ) : (
                                            <div className="delte text-red-600">*Deleted</div>
                                        )}
                                    </>) : (
                                        <>
                                            {(post?.isDeleted) && (
                                                <div className="delte text-red-600">*Deleted</div>
                                            )}
                                        </>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="desCont mb-2 px-4 py-3 w-full">
                            <div>
                                <span className="post_description poppins-semibold">
                                    {post?.description}
                                </span>
                            </div>
                        </div>
                        {post?.post_image?.length > 0 && (
                            <div className="col-12 mt-3 mb-4 p-0 request_post_image_box">
                                {post?.post_image?.length > 0 && (
                                    <div className="slider_container">
                                        <Slider {...settings}>
                                            {post?.post_image?.length > 0 &&
                                                post?.post_image?.map((item, idx) => {
                                                    return (
                                                        <div>
                                                            <img
                                                                key={idx}
                                                                src={`${IP + item}`}
                                                                className="request_post_image"
                                                                alt="img"
                                                                onError={(e) => {
                                                                    e.target.src = "/images/no-image5.png";
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                        </Slider>
                                        {post?.post_image?.length > 1 && (
                                            <span className="post_image_count d-flex align-items-center justify-content-center">
                                                {currentSlide}/{post?.post_image?.length}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="flex justify-content-between align-items-center border-b-4 pb-2 cursor-pointer">
                            <small
                                className="poppins-semibold ms-4 flex"
                            >
                                {!postLikeClick ? (
                                    <img
                                        src={assets.LikeIcon}
                                        className="like_shear_img"
                                        onClick={post?.isDeleted ? () => { } : handelPostLike}
                                        alt=""
                                    />
                                ) : (
                                    <img
                                        src={assets.LikeActiveIcon}
                                        className="like_shear_img"
                                        onClick={handelPostLike}
                                        alt=""
                                    />
                                )}{" "}
                                <span className="ms-1 poppins-semibold mt-1 z-[999px]">
                                    {postLlikeCount}{" "}
                                    <Popup
                                        on="click"
                                        style={{ zIndex: "9999" }}
                                        open={isOpen}
                                        trigger={
                                            postLikeClick ? (
                                                <span
                                                    onClick={() => {
                                                        setIsOpen(!isOpen);
                                                    }}
                                                >
                                                    Likes
                                                </span>
                                            ) : (
                                                <span
                                                    onClick={() => {
                                                        setIsOpen(!isOpen);
                                                    }}
                                                >
                                                    {" "}
                                                    Likes
                                                </span>
                                            )
                                        }
                                        position="bottom-right"
                                        content={
                                            <LikePopUp
                                                post={replycpy}
                                                likedRes={likedRes || {}}
                                                setIsOpen={setIsOpen}
                                            />
                                        }
                                    />
                                </span>
                            </small>
                            <div className="me-4 flex">
                                <img
                                    src={assets.CommentIcon}
                                    className="like_shear_img mr-1"
                                    alt=""
                                />
                                <small className="poppins-semibold ms-1 me-2">
                                    {/* {commentLength
                                        ? post?.comment_count + commentLength
                                        : post?.comment_count} */}
                                    {!post.isDeleted ? countComment : 0}
                                </small>
                                <small className="poppins-semibold ">Comments</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {postEdit && (
                <CreatePostFirst
                    editingMode={true}
                    post={post}
                    setClickPost={setPostEdit}
                    clickPost={postEdit}
                    refetch1={refetch}
                    setIsPostCreated2={setIsPostCreated1}
                />
            )}

            {postThreedot && (
                <div ref={popupRef} className="Post_popupBox">
                    <ThreeDot_Post_Popup
                        setPostThreedot={setPostThreedot}
                        setPostEdit={setPostEdit}
                        post_id={post?.id}
                        communityId={community?.id}
                        members={members}
                        post={post}
                    />
                </div>
            )}
        </>
    )
}

export default PostImagePopup;
